// @flow
/* eslint-disable ta-code-conventions/has-matching-test */

import * as React from 'react';
import { NavigableList } from '@ta/list.navigable-list';
import TypeaheadJsonResult from '../results/TypeaheadJsonResult';
import type { TypeaheadResult } from '../TypeaheadResult';

import Selector from './Selector';
import TypeaheadJsonFetcher from '../fetchers/TypeaheadJsonFetcher';

type Props = {|
  /** The currently selected result. */
  selectedLocation: TypeaheadResult,
  /** Callback triggered when the selection changes. */
  selectionChanged: TypeaheadResult => void,
  /** Placeholder text */
  placeholderText?: string,
|};

type State = {|
  textInputValue: string,
|};

/**
 * Component that lets you pick a location, specifically POIs, with typeahead support.
 */
class POISelector extends React.Component<Props, State> {
  state = {
    textInputValue: '',
  };

  onResultSelected = (selectedResult: TypeaheadResult) => {
    this.props.selectionChanged(selectedResult);
    this.setState({ textInputValue: selectedResult.displayValue || '' });
  };

  typeaheadJsonFetcher = new TypeaheadJsonFetcher({
    interleaved: true,
    types: ['hotel', 'attr', 'eat'],
    filter: ['nobroad'],
    name_depth: 1,
    details: true,
    legacy_format: true,
    urlList: false,
    max: 8,
  });

  textInputChanged = (newValue: string) => {
    this.setState({ textInputValue: newValue });
  };

  render() {
    return (
      <Selector
        fetchers={[this.typeaheadJsonFetcher]}
        typeaheadTextInputValue={this.state.textInputValue}
        selectionChanged={this.onResultSelected}
        textInputChanged={this.textInputChanged}
        placeHolder={this.props.placeholderText}
      >
        {(results, tracker, onSelection) => (
          <NavigableList>
            {[...(results.typeaheadjson || [])].map(r => (isActive, onMouseMove) => (
              <TypeaheadJsonResult
                result={r}
                tracker={tracker}
                onMouseMove={onMouseMove}
                onSelection={onSelection}
                active={isActive}
                key={`result=${r.value}`}
                includeIcon
              />
            ))}
          </NavigableList>
        )}
      </Selector>
    );
  }
}

export default POISelector;
